// extracted by mini-css-extract-plugin
module.exports = {"socials":"socials-527b684a","text":"text-f9d06bec","social-button":"social-button-3a9bc0ed","socialButton":"social-button-3a9bc0ed","overflowWrap":"overflowWrap-441e33be"};